import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "../components/Reveal";

export const Gallery = ({ items }) => (
  <section id="work" className="relative py-28 sm:py-36 overflow-hidden" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          <Eyebrow>Recent work</Eyebrow>
          <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-5xl font-medium tracking-tight text-[#F5F3EF] leading-[1.15]">
            See what's <span className="foil-text italic">possible.</span>
          </h2>
        </div>
        <p className="text-sm text-[#A1A8B3] max-w-xs leading-relaxed">
          Spot-colour logos, full-colour wraps and gradient prints — recent tubes from the studio floor.
        </p>
      </Reveal>
      <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-testid="gallery-grid">
        {items.map((item, i) => (
          <Reveal key={item.url} delay={i * 0.07} y={20} className={i % 2 === 1 ? "lg:mt-10" : ""}>
            <motion.figure
              whileHover={{ y: -6 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="group relative rounded-2xl overflow-hidden border border-white/8 bg-[#14171D]"
              data-testid={`gallery-item-${i}`}
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={item.url}
                  alt={item.caption}
                  loading="lazy"
                  className="product-img w-full h-full object-cover"
                />
              </div>
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0B0D10]/90 to-transparent px-4 pt-10 pb-3.5">
                <span className="font-mono-spec text-[9px] uppercase tracking-[0.2em] text-[#D9A76A]">{item.caption}</span>
              </figcaption>
            </motion.figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
